import { useEffect, useCallback } from 'react'

/**
 * AboutModal -- Display application information and licensing.
 *
 * Matches legacy: aboutModal.tpl.html (app-level info dropdown expanded to modal)
 */

export interface AboutModalProps {
    isOpen: boolean
    onClose: () => void
}

export function AboutModal({ isOpen, onClose }: AboutModalProps) {
    const handleKeyDown = useCallback(
        (e: KeyboardEvent) => {
            if (e.key === 'Escape') onClose()
        },
        [onClose],
    )

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown)
            document.body.classList.add('modal-open')
        }
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
            document.body.classList.remove('modal-open')
        }
    }, [isOpen, handleKeyDown])

    if (!isOpen) return null

    const currentYear = new Date().getFullYear()

    const handleBackdropClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget) onClose()
    }

    return (
        <>
            <div className="aps-background-mask mask-is-active" />
            <div
                className="modal fade in"
                style={{ display: 'block' }}
                role="dialog"
                tabIndex={-1}
                onClick={handleBackdropClick}
            >
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                type="button"
                                className="close"
                                onClick={onClose}
                                aria-label="Close"
                            >
                                &times;
                            </button>
                            <h4 className="modal-title">About</h4>
                        </div>
                        <div className="modal-body text-center">
                            <div id="logo-moreinfo-adsol" style={{ margin: '0 auto 20px' }} />
                            <h3>APS Dispute Management</h3>
                            <p className="text-muted">
                                This is a licensed copy of Advantage Solutions, a product of Advantage Payment Services.
                            </p>
                            <hr />
                            <p className="text-muted small">
                                &copy; {currentYear} Advantage Payment Services. All rights reserved.
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-default" onClick={onClose}>
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
